module.exports = __webpack_public_path__ + "static/media/randomBoxTypeImg.63279a1e.png";